import React, { useState } from "react";
import "./news.css";
import { KeyboardArrowDown, Close } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

const Accordion = ({ item }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="accordion-item">
      <div id="news-heading">
        <div id="news-img">
          <img src={item.image} />
        </div>
        <div id="news-title">{item.title}</div>
        <IconButton variant="contained"
          aria-label="delete"
          id="news-btn"
          onClick={() => setIsActive(!isActive)}  
          // color="primary"
        > 
          {isActive ? <Close /> : <KeyboardArrowDown />}
        </IconButton>
      </div>
      {isActive && (
        <div id="news-content">
          {item.description}
          <span>...</span>
          <a href={item.url} target="_blank">
            Read More
          </a>
        </div>
      )}
    </div>
  );
};

export default Accordion;
